/**
 * Imágenes del producto (DPS46 · Breathwork Session Ready).
 *
 * HERO_MOCKUP  ← "DPS46 - Principal - Breathwork Session Ready.png"
 * BONUS_COVERS ← "DPS46 - Bono 1..5 - <nombre>.png"
 *
 * Las páginas reales del tomo para el carrusel viven en data/volumePages.ts.
 */
export const HERO_MOCKUP: string | null =
  'https://cdn.magicpatterns.com/uploads/8pvEwvHsaeg2FTfFeAkMDk/breath_-_Ultra-realistic-product-photography-hor.png'

export const BONUS_COVERS: Record<string, string | null> = {
  '01': 'https://cdn.magicpatterns.com/uploads/hspXyDQazCWTZswjfLtFVR/DPS46_-_Bono_1_-_The_Printable_Breath_Card_Deck.png',
  '02': 'https://cdn.magicpatterns.com/uploads/iGv8mAdmTqRswJoXnaDryL/DPS46_-_Bono_2_-_See_One_Session,_Start_to_Finish.png',
  '03': 'https://cdn.magicpatterns.com/uploads/uvJqiy1KE16ghHohc9GGTP/DPS46_-_Bono_3_-_The_7-Day_Start_Plan.png',
  '04': 'https://cdn.magicpatterns.com/uploads/xqM3fM3g1BJwYvWnjnKb5L/DPS46_-_Bono_4_-_Find_Your_Facilitator_Voice_-_7_Rehearsal_Drills.png',
  '05': 'https://cdn.magicpatterns.com/uploads/kE8i4FwajNih7tL56w7Yk9/DPS46_-_Bono_5_-_Make_It_Yours_-_Using_the_Pack_With_Your_Own_Training.png',
}
